import { CardBlockImage } from "entities/modules/types";
import { THREE_CARD_BLOCK_KEY } from "entities/modules/utils";
import { doc, getDoc, serverTimestamp, updateDoc } from "firebase/firestore";
import { ref, uploadBytes } from "firebase/storage";
import { db, store } from "shared/api/firebase";
import { PageModuleData } from "../types";

type Params = {
  brandId: string;
  moduleId: string;
  pageId: string;
  cardBlockImages: CardBlockImage[];
};

export const savePageContentBlocksModuleImage = async ({
  brandId,
  moduleId,
  pageId,
  cardBlockImages,
}: Params) => {
  try {
    const docRef = doc(
      db,
      `brands/${brandId}/pages/${pageId}/modules/${moduleId}`,
    );

    const moduleData = (await getDoc(docRef)).data() as PageModuleData;

    if (!moduleData.contentBlocks || !moduleData.contentBlocks.length) {
      return null;
    }

    const contentBlocks = await Promise.all(
      cardBlockImages.map(async (imageFile, index) => {
        if (!imageFile) {
          return null;
        }

        // References for logo and background images
        const path = `brands/${brandId}/pages/${pageId}/modules/${moduleId}/${THREE_CARD_BLOCK_KEY}-${index}`;
        const imgStorageRef = ref(store, path);

        await uploadBytes(imgStorageRef, imageFile);

        const block = moduleData.contentBlocks?.find((i, idx) => idx === index);

        return { ...block, backgroundImage: path };
      }),
    );

    await updateDoc(docRef, {
      contentBlocks,
      updatedAt: serverTimestamp(),
    });
  } catch (error) {
    console.error("Error saving page module image:", error);
    throw error; // Or handle it in a way that's appropriate for your app
  }
};
